import React from 'react'
import CommonSectionCategory from '../../../Shared/CommonSectionCategory';
import { categoryModel } from '../../../Model/categoryCons';

const SecurityAndSafetyCategory = () => {
    return (
        <>
            <CommonSectionCategory props={categoryModel.SecurityAndSafety} />
        </>
    )
}

export default SecurityAndSafetyCategory;